import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { ReactNode } from "react";

interface DialogModalProps extends DialogProps {
  title: string;
  children: ReactNode;
  open: boolean;
}

const DialogModal = ({ title, children, open, ...rest }: DialogModalProps) => {
  return (
    <Dialog open={open} disableEnforceFocus {...rest}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default DialogModal;
